module.exports = __webpack_public_path__ + "img/load.72fa0620.svg";